import React, { useEffect, useState } from 'react'
import { resolveStorageUrl } from '../lib/storage'

// <img> for files in private Supabase buckets.
export default function PrivateImage({ src, alt = '', ...rest }) {
  const [url, setUrl] = useState(null)
  useEffect(() => {
    let alive = true
    setUrl(null)
    resolveStorageUrl(src).then(u => { if (alive) setUrl(u) })
    return () => { alive = false }
  }, [src])
  if (!url) return <div aria-label={alt} style={{ ...(rest.style || {}), background: 'var(--gray-100, #f3f4f6)' }} />
  return <img src={url} alt={alt} {...rest} />
}
